enum errorCodes {
  PBMEDResourceNotFound = "PBMEDResourceNotFound",
  PBMEDAlreadyOnboarded = "PBMEDAlreadyOnboarded"
}

export default errorCodes
